import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-expense-type-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(ExpenseTypeMultiSelectSearchControlComponent)
    ]
})
export class ExpenseTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.expense-type.noExpense", value: "No Expense"},
            {label: "wbo.bi.search.option.expense-type.unavailable", value: "Unavailable"},
            {label: "wbo.bi.search.option.expense-type.expenseAccount", value: "Expense Account"},
            {label: "wbo.bi.search.option.expense-type.outgoingAccount", value: "Outgoing Account"},
            {label: "wbo.bi.search.option.expense-type.loyaltyRedemption", value: "Loyalty Redemption"},
            {label: "wbo.bi.search.option.expense-type.multiple", value: "Multiple"}
        ]);
    }
}
